import { render, staticRenderFns } from "./OpenBankingDefaultDescription.vue?vue&type=template&id=4737f1d9&scoped=true"
import script from "./OpenBankingDefaultDescription.vue?vue&type=script&lang=js"
export * from "./OpenBankingDefaultDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4737f1d9",
  null
  
)

export default component.exports